import React, { Component } from 'react';
import { Select, Form } from 'antd';
import styles from './FieldInput.module.scss'

const { Option } = Select;

function SelectFieldAnt({ input, label, tooltip, options = [], meta: { touched, error }, inputProps, handleChange, disabled }) {
  return (
    <div className={styles.FieldInput}>
      <Form.Item
        style={{
          flexDirection: 'column',
          width: '100%',
          marginBottom: touched && error && 24 || 20,
        }}
        label={label}
        validateStatus={touched && error && "error" || null}
        help={touched && error || null}
        tooltip={tooltip && { title: tooltip }}
      >
        <Select
          allowClear
          value={input.value == 0 ? '' : input.value}
          {...inputProps}
          disabled={disabled}
          onChange={(e) => {
            if (handleChange) {
              handleChange(e);
            }
            input.onChange(e);
          }}
          status={touched && error && "error" || null}
        >
          {options.map((item, _i) => <Option key={'opt_' + input.name + _i} value={item.value}>{item.title}</Option>)}
        </Select>
      </Form.Item>
      {/* {touched && ((error && <span style={{ color: '#f04d4d', fontSize: 14 }}>{error}</span>))} */}
    </div>
  );
}

export default SelectFieldAnt
